
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battery-charge",
      function () {
        return require("private-next-pages/battery-charge/index.jsx");
      }
    ]);
  